<div class="number-counter-container" [ngClass]="{'gap-x': ncGap > 0}" [style.--gap.px]="ncGap">
  <div class="digit-wrapper" *ngFor="let digit of digits; let i = index">
    <div class="digits-strip"
      [@countAnimation]="{value: digit.state, params: {duration: ncDuration, delay: digit.delay, finalPosition: digit.targetPosition}}">
      <div class="digit" *ngFor="let num of digit.numbers">{{num}}</div>
    </div>
  </div>
</div>